// extracted by mini-css-extract-plugin
export default {"modal":"modal--aa3593b6db6aed1af43a"};